/**
 * Constants for Calendar view.
 */

export const DAY_NAMES = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
export const DAY_NAMES_LONG = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
export const MONTH_NAMES = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export const DEFAULT_HOUR_START = 0;
export const DEFAULT_HOUR_END = 24;
export const ALL_DAY_MIN_WIDTH = 120; // min width for all-day column

export const STATUS_OPTIONS = [
    { value: 'aktiv', label: 'Aktiv', color: '#137333' },
    { value: 'pausiert', label: 'Pausiert', color: '#B06000' },
    { value: 'abgeschlossen', label: 'Abgeschlossen', color: '#1A73E8' },
    { value: 'undatiert', label: 'Undatiert', color: '#5F6368' }
];
